import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";


export const subAdmin = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubAdmin: builder.query<
      CommonResponseType & { data: any },
      {
        page?: any;
        limit?: any;
        search?: any;
      }
    >({
      query: (params) => {
        const paramArray = [];
        let url = END_POINTS.getSubAdmin;
        if (params?.page) {
          paramArray.push(`page=${params?.page}`);
        }
        if (params?.limit) {
          paramArray.push(`limit=${params?.limit}`);
        }
        if (params?.search) {
          paramArray.push(`search=${params?.search}`);
        }
        if (paramArray?.length) {
          url += `?${paramArray.join("&")}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getSubAdminById: builder.query<CommonResponseType & { data: any }, { id: any }>(
      {
        query: ({ id }) => ({
          url: `${END_POINTS.getSubAdminById}/${id}`,
          method: "GET",
        }),
      }
    ),
    addSubAdmin: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addsubAdmin,
        method: "POST",
        body,
      }),
    }),
    updateSubAdmin: builder.mutation<CommonResponseType, { body: any; id: any }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSubAdmin}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteSubAdmin: builder.mutation<CommonResponseType, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSubAdmin}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddSubAdminMutation,
  useLazyGetSubAdminByIdQuery,
  useGetSubAdminByIdQuery,
  useLazyGetSubAdminQuery,
  useGetSubAdminQuery,
  useUpdateSubAdminMutation,
  useDeleteSubAdminMutation,
} = subAdmin;
